export function makeEmptyStack() {
  return { id: null, count: 0, durability: null };
}

/** Alias — chest / furnace systems use the shorter name. */
export const makeStack = makeEmptyStack;

export function cloneStack(stack) {
  return { id: stack.id, count: stack.count, durability: stack.durability };
}

export function clearStack(stack) {
  stack.id = null;
  stack.count = 0;
  stack.durability = null;
}

export function isEmptyStack(stack) {
  return !stack.id || stack.count <= 0;
}

/** Alias — chest / furnace systems use this name. */
export const isStackEmpty = isEmptyStack;

export function getStackMax(itemDefs, itemId) {
  return itemDefs[itemId]?.stack || 64;
}
